import { combineReducers } from 'redux';
import { IPricingUi } from '../../data/entities/pricing';
import { Actions } from './actions';

export const byPropertyId = (state = {} as { [id: string]: IPricingUi[] }, action: Actions = {} as any) => {
	switch (action.type) {
		case 'PRICING_GET_BY_ID_RECEIVE':
		case 'PRICING_UPDATE_RECEIVE':
		case 'PRICING_REMOVE_RECEIVE':
			return { ...state, [action.payload.id]: action.payload.pricingPeriods };
		default:
			return state;
	}
};

interface IPricingState {
	byPropertyId: ReturnType<typeof byPropertyId>;
}
export default combineReducers<IPricingState>({
	byPropertyId,
});
